/** The regulator's dates, and the lengths of time it states, for a filing - read from regime rows.
 *
 * Each entry arrives on the obligation (`key_dates`, from a `watch_for` or `period` deadline row,
 * verification log C-24) with a short label, the row's own sentence, and a source link. **Nothing here
 * is typed by a screen**: the words are the row's, and a regime that holds none prints nothing.
 *
 * What this never does: count down to a date (the regulator's act is not the company's deadline),
 * state a fee amount (none is established), or invent the date a length of time starts from. A watch
 * date prints as a date; a stated length prints as its length.
 */

import type { KeyDate } from "../lib/keyDates";
import { keyDateName, keyDateValue } from "../lib/keyDates";
import styles from "./KeyDates.module.css";

/** The full entries, each with its sentence, what a length is counted from, and its source link. */
export function KeyDatesList({ items, testId = "key-dates" }: { items: readonly KeyDate[]; testId?: string }) {
  if (items.length === 0) return null;
  return (
    <ul className={styles.list} data-testid={testId}>
      {items.map((item) => (
        <li key={item.key} className={styles.item} data-key={item.key} data-kind={item.kind}>
          <strong>
            {keyDateName(item)}
            {keyDateValue(item) ? `: ${keyDateValue(item)}` : ""}
          </strong>
          <span>{item.label}.</span>
          {item.runs_from ? <span>Counted from {item.runs_from}.</span> : null}
          {item.limitation ? <span>{item.limitation}</span> : null}
          <a href={item.source_url} target="_blank" rel="noreferrer">
            {item.citation}
          </a>
        </li>
      ))}
    </ul>
  );
}
